import { Injectable, EventEmitter, Input, Output } from '@angular/core';
import { Response, RequestOptionsArgs, RequestOptions } from '@angular/http';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from "@angular/router";
import { Source } from "../models/Source";
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/catch';
import { UserService } from './userService';
import { PlatformLocation } from '@angular/common';

@Injectable()
export class AuthService {

  @Output() onLogin = new EventEmitter<boolean>();
  constructor(private userService: UserService,
    private http: HttpClient,
    private router: Router,
    private location: PlatformLocation
  ) {
  }

  authenticate() {
    var token = sessionStorage.getItem('token');
    if (token == null) {
      this.router.navigate(['login']);
    }
    else {
      this.userService.getCurrentUser().subscribe(user => {
        sessionStorage.setItem("canView", user.CanViewResults.toString())
        if (user.IsPasswordNeedReset) {
          this.router.navigate(['manage/change-password']);
        }
        else {
          if (user.HasAcceptedTandC) {
            var source = sessionStorage.getItem("source");
            console.log(source, user);
            if (source == null && !user.CanSeeAllSiteResults) {//user.CanRequest) {//!user.CanSeeAllSiteResults) { // if user CanSeeAllSiteResults sessionStorage.setItem("source") to empty source, don't navigate.
              this.router.navigate(['Source']);
            }
            else if (source == null && user.CanSeeAllSiteResults && user.CanRequest) {
              this.router.navigate(['Source']);
            }
            else if (source == null && user.CanSeeAllSiteResults && !user.CanRequest) {
              let source = {
                UserSourceId: 0,
                Id: 0,
                SourceCode: "",
                SourceName: "",
                Site: user.Site
              }
              sessionStorage.setItem('source', JSON.stringify(source));
              this.router.navigate(['manage/result-list']);
            }
          }
          else {
            this.router.navigate(['accept']);
          }
        }
      });
    }
  }

  isInRole(role): Observable<boolean> {

    let headers = new HttpHeaders();
    headers = headers.append("Authorization", 'Bearer ' + JSON.parse(sessionStorage.getItem('token')).access_token);
    headers = headers.append("Content-Type", "application/json");
    return this.http.get<boolean>(this.location.getBaseHrefFromDOM() + 'api/users/isinrole/' + role, { headers: headers });
  }
  setLoginSource(source: Source) {
    if (source !== undefined) {
      sessionStorage.setItem("source", JSON.stringify(source));
    }
    this.sendLoginEvent(true);
  }

  getLoginSource(): Source {
    var sourceString = sessionStorage.getItem('source');
    if (sourceString == null) {
      return null;
    }

    return JSON.parse(sourceString);
  }

  login(userName: string, password: string) {
    var data = "grant_type=password&username=" + userName + "&password=" + encodeURIComponent(password);
    var loginData = { grant_type: 'password', userName: userName, password: encodeURIComponent(password) };

    let headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded;' });
    return this.http.post(this.location.getBaseHrefFromDOM() + "token", data, { headers: headers }).catch(this.handleError);

  }

  sendLoginEvent(logedIn: boolean) {
    this.onLogin.emit(logedIn);
  }

  logout() {
    sessionStorage.removeItem('source');
    sessionStorage.removeItem('token');
  }
  deleteStoredSource() {
    sessionStorage.removeItem('source');
  }
  IsAuthenticated(): boolean {
    let token = sessionStorage.getItem('token');
    if (token != null) {
      let source = sessionStorage.getItem('source');
      if (source != null) {
        return true;
      }
    }
    return false;
  }
  /*
  getApk() : any {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", 'Bearer ' + JSON.parse(sessionStorage.getItem('token')).access_token);
    //headers = headers.append("Content-Type", "application/json");
    headers = headers.append("Accept", "application/vnd.android.package-archive");
    return this.http.get(this.location.getBaseHrefFromDOM() + 'apk/com.tdlpathology.apk',
      { headers: headers, responseType: 'blob' as 'json', observe: 'response' as 'response' }).toPromise();
  }
  */

  handleError(error: Response) {
    return Observable.throw(error);
  }
}
